import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import ConnectionStatus from "./ConnectionStatus";
import { useCredits } from "../hooks/useCredits";
import { Button } from "@dawa/ui";

const links = [
  { to: "/content/new", label: "Nouveau" },
  { to: "/contents", label: "Mes contenus" },
  { to: "/personas", label: "Personas" },
  { to: "/projects", label: "Projets" },
  { to: "/writers", label: "Rédacteurs" },
  { to: "/billing", label: "Facturation" },
  { to: "/contact", label: "Contact" },
  { to: "/settings", label: "Réglages" },
];

export default function Header({ onToggleSidebar, hideNav = false }: { onToggleSidebar?: () => void; hideNav?: boolean }) {
  const [open, setOpen] = useState(false);
  const { credits } = useCredits();

  const NavLinks = () => (
    <>
      {links.map(({ to, label }) => (
        <NavLink
          key={to}
          to={to}
          onClick={() => setOpen(false)}
          className={({ isActive }) => (isActive ? "font-semibold underline" : "hover:underline")}
        >
          {label}
        </NavLink>
      ))}
      <NavLink
        to="/credits"
        onClick={() => setOpen(false)}
        className={({ isActive }) => (isActive ? "font-semibold underline" : "hover:underline")}
      >
        Crédits: {credits}
      </NavLink>
    </>
  );

  return (
    <header className="sticky top-0 z-40 border-b border-muted/20 bg-surface p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <Link to="/" className="font-bold">
          DawaRedacc
        </Link>
        {!hideNav && (
          <nav aria-label="Navigation principale" className="hidden items-center gap-4 md:flex">
            <NavLinks />
          </nav>
        )}
        <div className="flex items-center gap-2">
          <ConnectionStatus />
          <Button
            variant="ghost"
            size="sm"
            className="md:hidden"
            onClick={() => {
              if (onToggleSidebar) onToggleSidebar();
              else setOpen((o) => !o);
            }}
            aria-label="Menu"
            aria-expanded={open}
            aria-controls="mobile-nav"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </Button>
        </div>
      </div>
      {!onToggleSidebar && (
        <nav
          id="mobile-nav"
          aria-label="Navigation principale"
          className={`${open ? "flex" : "hidden"} flex-col gap-2 pt-4 md:hidden`}
        >
          <NavLinks />
        </nav>
      )}
    </header>
  );
}
